import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../Components/CSS/FilterStyle.css";

class RoleFilter extends Component {
  render() {
    const { classes, data, handleSearch } = this.props;
    return (
      <div className={classes.root}>
        <div className={classes.title}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="role"
            select
            label="User Role"
            variant="outlined"
            margin="normal"
            style={{ marginRight: 20 }}
            SelectProps={{ native: true }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.role}
            onChange={handleSearch}
          >
            <option value="">Select Any One</option>
            <option value="Accountant">Accountant</option>
            <option value="Librarian">Librarian</option>
          </TextField>
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(RoleFilter);
